import { render, staticRenderFns } from "./Level1.vue?vue&type=template&id=234cd29f&scoped=true"
import script from "./Level1.vue?vue&type=script&lang=js"
export * from "./Level1.vue?vue&type=script&lang=js"
import style0 from "./Level1.vue?vue&type=style&index=0&id=234cd29f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "234cd29f",
  null
  
)

export default component.exports